import TypeToReducer from 'type-to-reducer';
import { normalize, schema } from 'normalizr';

import {
  GET_SUBACCOUNTS,
  SET_SUBACCOUNTS_PAGINATION,
  SET_SUBACCOUNTS_FILTERS,
  RESET_SUBACCOUNTS,
  TOGGLE_SUBACCOUNT,
} from 'subaccounts/constants';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const subaccount = new schema.Entity('subaccounts');

export const initialState = {
  filters: {
    fulltext: '',
    columnSearch: ['key', 'name', 'description', 'account'],
  },
  pagination: {
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
    orderBy: 'createdAt',
    order: 'desc',
  },
  isLoading: false,
  needFetch: false,
  entities: { subaccounts: {} },
  result: { subaccounts: [] },
};

export const getPending = (state) => ({ ...state, isLoading: true, needFetch: false });

export const getFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  pagination: {
    ...state.pagination,
    limit: payload.limit,
    page: payload.page,
    totalPages: payload.totalPages,
    totalDocs: payload.totalDocs,
  },
  ...normalize({ subaccounts: payload.records }, { subaccounts: [subaccount] }),
});

export const getRejected = (state) => ({ ...state, isLoading: false });

export const setPagination = (state, { payload }) => ({
  ...state,
  needFetch: true,
  pagination: { ...state.pagination, ...payload },
});

export const setFilters = (state, { payload }) => ({
  ...state,
  needFetch: true,
  filters: { ...state.filters, ...payload },
});

export const reset = (state) => ({ ...initialState });

export const togglePending = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    subaccounts: {
      ...state.entities.subaccounts,
      [meta.id]: { ...state.entities.subaccounts[meta.id], isLoading: true },
    },
  },
});

export const toggleRejected = (state, { meta }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    subaccounts: {
      ...state.entities.subaccounts,
      [meta.id]: { ...state.entities.subaccounts[meta.id], isLoading: false },
    },
  },
});

export const toggleFulfilled = (state, { payload }) => ({
  ...state,
  isLoading: false,
  entities: {
    ...state.entities,
    subaccounts: {
      ...state.entities.subaccounts,
      [payload.account.id]: { ...payload.account, isLoading: false },
    },
  },
});

const reducers = {
  [GET_SUBACCOUNTS]: {
    [PENDING]: getPending,
    [FULFILLED]: getFulfilled,
    [REJECTED]: getRejected,
  },
  [SET_SUBACCOUNTS_PAGINATION]: setPagination,
  [SET_SUBACCOUNTS_FILTERS]: setFilters,
  [RESET_SUBACCOUNTS]: reset,
  [TOGGLE_SUBACCOUNT]: {
    [PENDING]: togglePending,
    [FULFILLED]: toggleFulfilled,
    [REJECTED]: toggleRejected,
  },
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/reducers/subaccounts_list_reducers.js